import React, {Component} from 'react';
import s from "./App.module.scss"
import HomePage from "./pages/Home";
import LoginPage from "./pages/Login";
import {Layout, Menu, Spin} from "antd";
import TestContext from "./context/testContext";
import FirebaseContext from "./context/firebaseContext";

import { BrowserRouter, Route, Link, Switch, Redirect } from 'react-router-dom';
import ContentBlock from "./components/ContentBlock";
import Header from "./components/Header";
import {PrivateRoute} from "./utils/privateRoute";
import AboutPage from "./pages/About";
import ContactPage from "./pages/Contact";
import CurrentCard from "./pages/CurrentCard";

class App extends Component {

    state = {
        user: null,
    }

    componentDidMount() {
        const {auth, setUserUid } = this.context;

        auth.onAuthStateChanged((user) => {
            if(user) {
                setUserUid(user.uid);
                localStorage.setItem('user', JSON.stringify(user));
                this.setState({
                    user,
                });
            } else {
                setUserUid(null);
                localStorage.removeItem('user');
                this.setState({
                    user: false,
                });
            }
        });
    }

    handleExit = (e) => {
        e.preventDefault();
        this.setState({
            user: false,
        });

    }

    render() {
        const {user} = this.state;

        if(user === null) {
            return (
                <div className={s.loader_wrap}>
                    <Spin size="large"/>
                </div>
            );
        }
        return (
            <>
                <Route path="/login" component={LoginPage}/>
                <Route render={(props) => {
                    const {history: {push}} = props;
                return(
                    <Layout>
                        <Header>
                            <Menu theme="dark" mode="horizontal">
                                <Menu.Item key="1">
                                    <Link to="/">Home</Link>
                                </Menu.Item>
                                <Menu.Item key="2">
                                    <Link to="/about">About</Link>
                                </Menu.Item>
                                <Menu.Item key="3">
                                    <Link to="/contact">Contact</Link>
                                </Menu.Item>
                                <span className={s.exit} >
                                    <span> Hello, {user.email}</span>
                                    <button onClick={this.handleExit}>Выйти</button>
                                </span>
                            </Menu>
                        </Header>
                        <ContentBlock>
                            <Switch>
                                <PrivateRoute path="/" exact component={HomePage}/>
                                <PrivateRoute path="/home"
                                       component={HomePage}
                                />
                                <PrivateRoute path="/word/:id?" component={CurrentCard}/>
                                <PrivateRoute path="/home/:id?/:isDone?" component={CurrentCard}/>
                                <PrivateRoute path="/about" component={AboutPage}/>
                                <PrivateRoute path="/contact" component={ContactPage}/>
                                <Redirect to="/" />
                            </Switch>
                        </ContentBlock>
                    </Layout>
                )}}/>
            </>

        );
    }
}

App.contextType = FirebaseContext;

export default App;